// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginDestinationTypeStep__item-a8f5df + .LoginDestinationTypeStep__item-a8f5df {
  margin-top: 16px;
}

.LoginDestinationTypeStep__illustration-b07212 {
  height: 56px;
  width: 56px;
}

:root[dir=rtl] .LoginDestinationTypeStep__arrowIcon-f0a48c {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/Login/LoginViews/LoginDestinationTypeStep/LoginDestinationTypeStep.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".item + .item {\n  margin-top: 16px;\n}\n\n.illustration {\n  height: 56px;\n  width: 56px;\n}\n\n:root[dir='rtl'] .arrowIcon {\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `LoginDestinationTypeStep__item-a8f5df`,
	"illustration": `LoginDestinationTypeStep__illustration-b07212`,
	"arrowIcon": `LoginDestinationTypeStep__arrowIcon-f0a48c`
};
module.exports = ___CSS_LOADER_EXPORT___;
